import { useState } from "react";
import { Eraser, Save } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const colors = ["#172033", "#0f766e", "#2563eb", "#dc2626", "#f59e0b", "#ffffff"];
const cells = Array.from({ length: 96 }, (_, index) => index);

export function PaintApp({ activeMachine, onRunCommand }: SimulatorAppSurfaceProps) {
  const [color, setColor] = useState(colors[1]);
  const [path, setPath] = useState("C:\\Users\\Student\\Pictures\\evidence.png");
  const [painted, setPainted] = useState<Record<number, string>>({
    18: colors[1],
    19: colors[1],
    31: colors[2],
    32: colors[2],
    44: colors[3],
    45: colors[3]
  });

  async function saveFile() {
    await onRunCommand({
      appId: "paint",
      commandType: "PAINT_SAVE_FILE",
      capability: "local.utility.write",
      label: `Save ${path}`,
      payload: {
        machineId: activeMachine,
        path,
        pixels: Object.keys(painted).length
      }
    });
  }

  return (
    <div className="fd-sim-app fd-paint">
      <div className="fd-sim-app-toolbar fd-paint-toolbar">
        <button type="button" onClick={() => setPainted({})}><Eraser size={16} /> Clear</button>
        <button type="button" onClick={() => void saveFile()}><Save size={16} /> Save</button>
        <label>
          Path
          <input value={path} onChange={(event) => setPath(event.target.value)} />
        </label>
        <div className="fd-paint-swatches" aria-label="Paint colors">
          {colors.map((swatch) => (
            <button
              aria-label={`Color ${swatch}`}
              className={swatch === color ? "is-active" : ""}
              key={swatch}
              style={{ background: swatch }}
              type="button"
              onClick={() => setColor(swatch)}
            />
          ))}
        </div>
      </div>
      <div className="fd-paint-canvas" aria-label="Paint canvas">
        {cells.map((cell) => (
          <button
            key={cell}
            style={{ background: painted[cell] ?? "#ffffff" }}
            type="button"
            onClick={() => setPainted((current) => ({ ...current, [cell]: color }))}
          />
        ))}
      </div>
    </div>
  );
}
